import Vue from "vue";
import Router from "vue-router";
// 解决重复点击路由会报错问题
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
Vue.use(Router);
let mobile = false;
if (window.screen.width >= 768) {
  // console.log("电脑");
  mobile = false;
} else {
  // console.log("手机");
  mobile = true;
}

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "/",
      redirect: "/pc"
    },
    {
      path: "/pc",
      name: "pc",
      redirect: "/pc/home",
      component: () => import("@/views/foreign/pc"),
      children: [
        {
          path: "/pc/home",
          name: "home",
          component: () => import("@/views/foreign/pc/home")
        },
        {
          path: "/pc/productList", //产品列表
          name: "productList",
          component: () => import("@/views/foreign/pc/productList")
        },
        {
          path: "/pc/productList_info", //产品详情
          name: "productList_info",
          component: () => import("@/views/foreign/pc/productList_info")
        },
        {
          path: "/pc/contact_us", //联系我们
          name: "contact_us",
          component: () => import("@/views/foreign/pc/contact_us")
        },
        {
          path: "/pc/about_us", //关于我们
          name: "about_us",
          component: () => import("@/views/foreign/pc/about_us")
        },
        {
          path: "/pc/schemeList", //方案列表
          name: "schemeList",
          component: () => import("@/views/foreign/pc/schemeList")
        },
        {
          path: "/pc/threeClassroom", //三个课堂
          name: "threeClassroom",
          component: () =>
            import("@/views/foreign/pc/schemeList/components/threeClassroom")
        },
        {
          path: "/pc/smartClasssroom", //K12全学科智能教室
          name: "smartClasssroom",
          component: () =>
            import("@/views/foreign/pc/schemeList/components/smartClasssroom")
        },
        {
          path: "/pc/intelligentRecord", //智能录制和广播解决方案
          name: "intelligentRecord",
          component: () =>
            import("@/views/foreign/pc/schemeList/components/intelligentRecord")
        },
        {
          path: "/pc/higherEdu", //高等教育解决方案
          name: "higherEdu",
          component: () =>
            import("@/views/foreign/pc/schemeList/components/higherEdu")
        },
        {
          path: "/pc/4k-record", //精品录播
          name: "4k-record",
          component: () =>
            import("@/views/foreign/pc/schemeList/4kRecord")
        },
        {
          path: "/pc/normalized-record", //常态化录播
          name: "normalized-record",
          component: () =>
            import("@/views/foreign/pc/schemeList/normalizedRecord")
        },
        {
          path: "/pc/dual-teacher", //双师课堂
          name: "dual-teacher",
          component: () =>
            import("@/views/foreign/pc/schemeList/remoteDualTeacher")
        },
        {
          path: "/pc/ai-behavior", //ai行为分析管理平台
          name: "ai-behavior",
          component: () =>
            import("@/views/foreign/pc/schemeList/aiBehavior")
        },
        {
          path: "/pc/portable-record", //便携录播
          name: "portable-record",
          component: () =>
            import("@/views/foreign/pc/schemeList/portableRecord")
        },
        {
          path: "/pc/exhibitions", //历届展会
          name: "exhibitions",
          component: () => import("@/views/foreign/pc/about_us/exhibitions")
        },
        {
          path: "/pc/news", // 新闻
          name: "news",
          component: () => import("@/views/foreign/pc/news/list")
        },
        {
          path: "/pc/news-detail/:id", // 新闻
          name: "news-detail",
          component: () => import("@/views/foreign/pc/news/detail")
        },
        {
          path: "/pc/privacy-policy", // 新闻
          name: "privacy-policy",
          component: () => import("@/views/foreign/pc/privacy-policy")
        },
        {
          path: "/pc/product-specification", // 产品规格
          name: "product-specification",
          component: () => import("@/views/foreign/pc/product-specification")
        },
      ]
    },
    {
      path: "/platform",
      name: "platform",
      redirect: "/platform/login",
      component: () => import("@/views/platform"),
      children: [
        {
          path: "/platform/login",
          name: "login",
          component: () => import("@/views/platform/login")
        },
        {
          path: "/platform/basic",
          name: "basic",
          redirect: "/platform/basic/scheme-type",
          component: () => import("@/views/platform/basic"),
          children: [
            // 方案类型
            {
              path: "/platform/basic/scheme-type",
              name: "scheme-type",
              component: () => import("@/views/platform/scheme/scheme-type")
            },
            // 方案组
            {
              path: "/platform/basic/scheme-solve",
              name: "scheme-solve",
              component: () => import("@/views/platform/scheme/scheme-solve")
            },
            // 方案详情
            {
              path: "/platform/basic/scheme-details",
              name: "scheme-details",
              component: () => import("@/views/platform/scheme/scheme-details")
            },
            // 产品分类
            {
              path: "/platform/basic/product-classify",
              name: "product-classify",
              component: () =>
                import("@/views/platform/product/product-classify")
            },
            // 产品类型
            {
              path: "/platform/basic/product-type",
              name: "product-type",
              component: () => import("@/views/platform/product/product-type")
            },
            // 产品详情
            {
              path: "/platform/basic/product-details",
              name: "product-details",
              component: () =>
                import("@/views/platform/product/product-details")
            },
            // 案例
            {
              path: "/platform/basic/case",
              name: "case",
              component: () => import("@/views/platform/case")
            },
            // 行业动态
            {
              path: "/platform/basic/industry-trends",
              name: "industry-trends",
              component: () => import("@/views/platform/industry-trends")
            },
            // 关于我们
            {
              path: "/platform/basic/about-us",
              name: "about-us",
              component: () =>
                import("@/views/platform/about-wenxiang/about-us")
            },
            // 联系我们
            {
              path: "/platform/basic/contact-us",
              name: "contact-us",
              component: () =>
                import("@/views/platform/about-wenxiang/contact-us")
            },
            // 历届展会
            {
              path: "/platform/basic/previous-exhibitions",
              name: "previous-exhibitions",
              component: () =>
                import("@/views/platform/about-wenxiang/previous-exhibitions")
            },
            // 资质荣誉
            {
              path: "/platform/basic/qualification-honor",
              name: "qualification-honor",
              component: () =>
                import("@/views/platform/about-wenxiang/qualification-honor")
            },
            // 人才招聘
            {
              path: "/platform/basic/talent-recruitment",
              name: "talent-recruitment",
              component: () =>
                import("@/views/platform/about-wenxiang/talent-recruitment")
            }
          ]
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js